export default function Value() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-[#6B4E9C]/10 text-[#6B4E9C] px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap mb-6">
            마지막 기준
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            한 잔에 담긴 가치
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            맛을 넘어 균형 있는 일상을 위한 항산화 성분을 생각합니다.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mt-16">
          {/* 왼쪽 이미지 */}
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/4593ebb7800e1b6a157f8235f0dc1e7b.jpg"
              alt="항산화 성분이 풍부한 포도즙"
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
          </div>

          {/* 오른쪽 텍스트 */}
          <div className="space-y-8">
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                포도에는 폴리페놀과 안토시아닌 같은 항산화 성분이 존재합니다.
              </p>
              <p className="font-semibold text-gray-900">
                정직한 원료와 공정이 이 가치를 흔들림 없이 전달합니다.
              </p>
            </div>

            <div className="bg-gradient-to-br from-[#FDFBF7] to-white rounded-xl p-8 border border-gray-200">
              <h4 className="font-bold text-xl text-gray-900 mb-4">항산화 성분</h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#6B4E9C]/10 rounded-full flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-[#6B4E9C]"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">폴리페놀</p>
                    <p className="text-sm text-gray-600">자연이 만든 항산화 물질</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#6B4E9C]/10 rounded-full flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-[#6B4E9C]"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">안토시아닌</p>
                    <p className="text-sm text-gray-600">포도의 진한 보라색을 만드는 성분</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#6B4E9C]/5 rounded-xl p-6 border border-[#6B4E9C]/20">
              <p className="text-gray-700 leading-relaxed">
                항산화 성분 섭취는 일상 속 균형 관리에 도움이 될 수 있습니다. 몸의 균형 관리는 작은 습관에서 시작됩니다. 포도즙 한 잔은 자연의 힘을 간편하게 담는 선택이 됩니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
